import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69b1d2fb886e100014e46a3d/gestpub_municipal_diagnostic/src/app/politica-de-privacidade/page.tsx");
